import 'regenerator-runtime/runtime';
import './i18n';
import React from 'react';
import * as ReactDOM from 'react-dom';
import {CONTAINER_ID} from './lib/constants';
import {Wrapper} from './components/Wrapper';

ReactDOM.render(<Wrapper/>, document.getElementById(CONTAINER_ID));